// (function () {
//   $.rails.allowAction = function (link) {
//     if (!link.attr('data-confirm')) {
//       return true;
//     }
//     $.rails.showConfirmDialog(link);
//     return false;
//   };
//
//   $.rails.confirmed = function (link) {
//     link.removeAttr('data-confirm');
//     return link.trigger('click.rails');
//   };
//
//   $.rails.showConfirmDialog = function (link) {
//     var html, message;
//     message = link.attr('data-confirm');
//     html = '<div class="ui basic modal" id="confirmationDialog">' +
//       '  <div class="ui icon header">' +
//       '    <i class="trash icon"></i>' +
//       message +
//       '  </div>' +
//       '  <div class="content">' +
//       '    <p>' + message + '</p>' +
//       '  </div>' +
//       '  <div class="actions">' +
//       '    <div class="ui red basic cancel inverted button">' +
//       '      <i class="remove icon"></i>' +
//       '      No' +
//       '    </div>' +
//       '    <div class="ui green ok inverted button confirm">' +
//       '      <i class="checkmark icon"></i>' +
//       '      Yes' +
//       '    </div>' +
//       '  </div>' +
//       '</div>';
//     $(html).modal('show');
//     return $('#confirmationDialog .confirm').on('click', function () {
//       return $.rails.confirmed(link);
//     });
//   };
//
// }).call(this);

function modalConfirmJs(message, confirm) {
  let html = '<div class="ui basic modal" id="confirmationDialog">' +
    '  <div class="ui icon header">' +
    '    <i class="trash icon"></i>' +
    message +
    '  </div>' +
    '  <div class="content">' +
    '    <p>' + message + '</p>' +
    '  </div>' +
    '  <div class="actions">' +
    '    <div class="ui red basic cancel inverted button">' +
    '      <i class="remove icon"></i>' +
    '      No' +
    '    </div>' +
    '    <div class="ui green ok inverted button confirm">' +
    '      <i class="checkmark icon"></i>' +
    '      Yes' +
    '    </div>' +
    '  </div>' +
    '</div>';
  $(html).modal('show');
  $('#confirmationDialog .confirm').on('click', function () {
    confirm(true);
  });
  $('#confirmationDialog .cancel').on('click', function () {
    confirm(false);
  });
};

export {modalConfirmJs};
